// Which corpus view a device shows (Settings > Interface > Corpus Panel). The
// names and components are in components/corpus/views/corpusViews.ts; this is
// only what the settings store needs to keep the choice.

export const CORPUS_VIEW_IDS = ['tree', 'jumpBar', 'library', 'columns', 'outline'] as const
export type CorpusViewId = typeof CORPUS_VIEW_IDS[number]
export const DEFAULT_CORPUS_VIEW: CorpusViewId = 'tree'

/** A saved choice, or the default when it names no view. */
export function normalizeCorpusView(value: unknown): CorpusViewId {
  return (CORPUS_VIEW_IDS as readonly unknown[]).includes(value) ? value as CorpusViewId : DEFAULT_CORPUS_VIEW
}
